/**
 * Approximate map centers (capitals / main cities) for DHL service-point map initial view.
 * Keys are ISO 3166-1 alpha-2 (plus IC / KV used in MySkladon).
 */
const DHL_COUNTRY_MAP_CENTERS: Record<string, [number, number]> = {
    AD: [42.5063, 1.5218],
    AE: [24.4539, 54.3773],
    AF: [34.5553, 69.2075],
    AG: [17.1274, -61.8468],
    AI: [18.2206, -63.0686],
    AL: [41.3275, 19.8187],
    AM: [40.1792, 44.4991],
    AO: [-8.839, 13.2894],
    AQ: [-75.2509, 0],
    AR: [-34.6037, -58.3816],
    AS: [-14.2756, -170.702],
    AT: [48.2082, 16.3738],
    AU: [-35.2809, 149.13],
    AW: [12.5211, -69.9683],
    AX: [60.1167, 19.9],
    AZ: [40.4093, 49.8671],
    BA: [43.8563, 18.4131],
    BB: [13.1132, -59.5988],
    BD: [23.8103, 90.4125],
    BE: [50.8503, 4.3517],
    BF: [12.3714, -1.5197],
    BG: [42.6977, 23.3219],
    BH: [26.2285, 50.586],
    BI: [-3.3614, 29.3599],
    BJ: [6.4969, 2.6289],
    BL: [17.9, -62.8333],
    BM: [32.2942, -64.7839],
    BN: [4.9031, 114.9398],
    BO: [-16.4897, -68.1193],
    BQ: [12.1696, -68.99],
    BR: [-15.8267, -47.9218],
    BS: [25.0443, -77.3504],
    BT: [27.4728, 89.639],
    BV: [-54.42, 3.35],
    BW: [-24.6282, 25.9231],
    BY: [53.9006, 27.559],
    BZ: [17.251, -88.759],
    CA: [45.4215, -75.6972],
    CC: [-12.1642, 96.871],
    CD: [-4.4419, 15.2663],
    CF: [4.3947, 18.5582],
    CG: [-4.2634, 15.2429],
    CH: [46.948, 7.4474],
    CI: [6.8276, -5.2893],
    CK: [-21.2367, -159.7777],
    CL: [-33.4489, -70.6693],
    CM: [3.848, 11.5021],
    CN: [39.9042, 116.4074],
    CO: [4.711, -74.0721],
    CR: [9.9281, -84.0907],
    CU: [23.1136, -82.3666],
    CV: [14.933, -23.5133],
    CW: [12.1696, -68.99],
    CX: [-10.4475, 105.6904],
    CY: [35.1856, 33.3823],
    CZ: [50.0755, 14.4378],
    DE: [52.52, 13.405],
    DJ: [11.5721, 43.1456],
    DK: [55.6761, 12.5683],
    DM: [15.3092, -61.3794],
    DO: [18.4861, -69.9312],
    DZ: [36.7538, 3.0588],
    EC: [-0.1807, -78.4678],
    EE: [59.437, 24.7536],
    EG: [30.0444, 31.2357],
    EH: [27.1536, -13.2033],
    ER: [15.3229, 38.9251],
    ES: [40.4168, -3.7038],
    ET: [9.032, 38.7469],
    FI: [60.1699, 24.9384],
    FJ: [-18.1416, 178.4419],
    FK: [-51.6964, -57.8517],
    FM: [6.9248, 158.161],
    FO: [62.0079, -6.7908],
    FR: [48.8566, 2.3522],
    GA: [0.4162, 9.4673],
    GB: [51.5074, -0.1278],
    GD: [12.0561, -61.7486],
    GE: [41.7151, 44.8271],
    GF: [4.9224, -52.3135],
    GG: [49.4657, -2.5853],
    GH: [5.6037, -0.187],
    GI: [36.1408, -5.3536],
    GL: [64.1814, -51.6941],
    GM: [13.4549, -16.579],
    GN: [9.6412, -13.5784],
    GP: [16.265, -61.551],
    GQ: [3.7504, 8.7371],
    GR: [37.9838, 23.7275],
    GS: [-54.2833, -36.5],
    GT: [14.6349, -90.5069],
    GU: [13.4443, 144.7937],
    GW: [11.8817, -15.6178],
    GY: [6.8013, -58.1551],
    HK: [22.3193, 114.1694],
    HM: [-53.1, 73.5],
    HN: [14.0723, -87.1921],
    HR: [45.815, 15.9819],
    HT: [18.5944, -72.3074],
    HU: [47.4979, 19.0402],
    IC: [28.1235, -15.4363],
    ID: [-6.2088, 106.8456],
    IE: [53.3498, -6.2603],
    IL: [31.7683, 35.2137],
    IM: [54.1523, -4.4861],
    IN: [28.6139, 77.209],
    IO: [-7.3195, 72.4229],
    IQ: [33.3152, 44.3661],
    IR: [35.6892, 51.389],
    IS: [64.1466, -21.9426],
    IT: [41.9028, 12.4964],
    JE: [49.2144, -2.1312],
    JM: [18.0179, -76.8099],
    JO: [31.9454, 35.9284],
    JP: [35.6762, 139.6503],
    KE: [-1.2921, 36.8219],
    KG: [42.8746, 74.5698],
    KH: [11.5564, 104.9282],
    KI: [1.3292, 172.979],
    KM: [-11.7172, 43.2473],
    KN: [17.3026, -62.7177],
    KP: [39.0392, 125.7625],
    KR: [37.5665, 126.978],
    KV: [42.6629, 21.1655],
    KW: [29.3759, 47.9774],
    KY: [19.2869, -81.3674],
    KZ: [51.1694, 71.4491],
    LA: [17.9757, 102.6331],
    LB: [33.8938, 35.5018],
    LC: [14.0101, -60.9875],
    LI: [47.141, 9.5209],
    LK: [6.9271, 79.8612],
    LR: [6.2907, -10.7605],
    LS: [-29.3151, 27.4869],
    LT: [54.6872, 25.2797],
    LU: [49.6116, 6.1319],
    LV: [56.9496, 24.1052],
    LY: [32.8872, 13.1913],
    MA: [33.9716, -6.8498],
    MC: [43.7384, 7.4246],
    MD: [47.0105, 28.8638],
    ME: [42.4304, 19.2594],
    MF: [18.0708, -63.0501],
    MG: [-18.8792, 47.5079],
    MH: [7.1315, 171.1845],
    MK: [41.9981, 21.4254],
    ML: [12.6392, -8.0029],
    MM: [16.8409, 96.1735],
    MN: [47.8864, 106.9057],
    MO: [22.1987, 113.5439],
    MP: [15.2123, 145.7545],
    MQ: [14.6415, -61.0242],
    MR: [18.0735, -15.9582],
    MS: [16.7425, -62.1874],
    MT: [35.8989, 14.5146],
    MU: [-20.1609, 57.5012],
    MV: [4.1755, 73.5093],
    MW: [-13.9626, 33.7741],
    MX: [19.4326, -99.1332],
    MY: [3.139, 101.6869],
    MZ: [-25.9692, 32.5732],
    NA: [-22.5609, 17.0658],
    NC: [-22.2758, 166.458],
    NE: [13.5137, 2.1098],
    NF: [-29.0408, 167.9547],
    NG: [9.0765, 7.3986],
    NI: [12.115, -86.2362],
    NL: [52.3676, 4.9041],
    NO: [59.9139, 10.7522],
    NP: [27.7172, 85.324],
    NR: [-0.5228, 166.9315],
    NU: [-19.0544, -169.8672],
    NZ: [-41.2865, 174.7762],
    OM: [23.588, 58.3829],
    PA: [8.9824, -79.5199],
    PE: [-12.0464, -77.0428],
    PF: [-17.5516, -149.5585],
    PG: [-9.4438, 147.1803],
    PH: [14.5995, 120.9842],
    PK: [33.6844, 73.0479],
    PL: [52.2297, 21.0122],
    PM: [46.7811, -56.1711],
    PN: [-25.0667, -130.1],
    PR: [18.4655, -66.1057],
    PS: [31.9522, 35.2332],
    PT: [38.7223, -9.1393],
    PW: [7.5149, 134.5825],
    PY: [-25.2637, -57.5759],
    QA: [25.2854, 51.531],
    RE: [-20.8823, 55.4504],
    RO: [44.4268, 26.1025],
    RS: [44.7866, 20.4489],
    RU: [55.7558, 37.6173],
    RW: [-1.9441, 30.0619],
    SA: [24.7136, 46.6753],
    SB: [-9.4456, 159.9729],
    SC: [-4.6191, 55.4513],
    SD: [15.5007, 32.5599],
    SE: [59.3293, 18.0686],
    SG: [1.3521, 103.8198],
    SH: [-15.965, -5.7089],
    SI: [46.0569, 14.5058],
    SJ: [78.2232, 15.6267],
    SK: [48.1486, 17.1077],
    SL: [8.4657, -13.2317],
    SM: [43.9424, 12.4578],
    SN: [14.7167, -17.4677],
    SO: [2.0469, 45.3182],
    SR: [5.852, -55.2038],
    SS: [4.8594, 31.5713],
    ST: [0.3386, 6.7311],
    SV: [13.6929, -89.2182],
    SX: [18.0425, -63.0548],
    SY: [33.5138, 36.2765],
    SZ: [-26.3054, 31.1367],
    TC: [21.694, -71.7979],
    TD: [12.1348, 15.0557],
    TF: [-49.28, 69.348],
    TG: [6.1256, 1.2224],
    TH: [13.7563, 100.5018],
    TJ: [38.5598, 68.774],
    TK: [-9.2002, -171.8484],
    TL: [-8.5569, 125.5603],
    TM: [37.9601, 58.3261],
    TN: [36.8065, 10.1815],
    TO: [-21.1393, -175.2049],
    TR: [39.9334, 32.8597],
    TT: [10.6918, -61.2225],
    TV: [-8.5211, 179.1962],
    TW: [25.033, 121.5654],
    TZ: [-6.7924, 39.2083],
    UA: [50.4501, 30.5234],
    UG: [0.3476, 32.5825],
    UK: [51.5074, -0.1278],
    UM: [19.2823, 166.647],
    US: [38.9072, -77.0369],
    UY: [-34.9011, -56.1645],
    UZ: [41.2995, 69.2401],
    VA: [41.9029, 12.4534],
    VC: [13.16, -61.2248],
    VE: [10.4806, -66.9036],
    VG: [18.4207, -64.64],
    VI: [18.3419, -64.9307],
    VN: [21.0278, 105.8342],
    VU: [-17.7333, 168.3273],
    WF: [-13.2825, -176.1764],
    WS: [-13.8507, -171.7513],
    YE: [15.3694, 44.191],
    YT: [-12.8275, 45.1662],
    ZA: [-25.7479, 28.2293],
    ZM: [-15.3875, 28.3228],
    ZW: [-17.8252, 31.0335],
};

/** Last-resort center when country code is unknown – keep neutral (not Prague). */
const FALLBACK_CENTER: [number, number] = [20, 0];

export const getDhlCountryMapCenter = (countryCode: string): [number, number] => {
    const code = countryCode.trim().toUpperCase();
    return DHL_COUNTRY_MAP_CENTERS[code] ?? FALLBACK_CENTER;
};
